<template>
    <div>
        <page-header :heading="pageHeader.title"
                     :buttons="pageHeader.buttons" />

        <search-form key="reportsSearch"
                     :inputs="searchInputs"
                     class="mb-5" 
                     @clear="handleClearClick"
                     @search="handleSearchClick" />
        <hr />
        <data-list :dataCols="cols"
                   :dataListItems="reportList"
                   :tableClass="'table table-striped table-sm'"
                   :actions="[{ id:1,name:'download',text:'Download', buttonClass:'btn btn-secondary btn-sm', iconClass:'fas fa-download'}]"
                   @action-click="handleActionClick"
                   @column-click="handleSortClick"
                   @pagination-input="handlePagination" />
        <hr />

        <loading :active.sync="isLoading"
                 :can-cancel="false"
                 :is-full-page="true"></loading>
    </div>
</template>

<script>

//import OrderBy from '@/components/OrderBy.vue'
import PageHeader from '@/components/PageHeader.vue'
import DataList from '@/components/DataListPagination.vue'


//import PageSize from '@/components/PageSize.vue'
import SearchForm from '@/components/SearchForm.vue'

import { mapActions, mapGetters } from 'vuex'

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

import { reportsApiService } from '@/services/reports-api.service.js'

let indexOfObject = function (array, prop, value) {
    for (var i = 0; i < array.length; i += 1) {
        if (array[i][prop] === value) {
            return i;
        }
    }
    return -1;
}

export default {
    name:'Reports',
    mixins: [

    ],
    components: {
        PageHeader,
        DataList,
        //PageSize,
        SearchForm,
        Loading,
        //OrderBy
    },
    data: () => {
        return {
            pageHeader: {
                title: 'Reports',
            },

            searchInputs: [
            {
                id: 'reportType',
                label: 'Report type',
                type: 'select',
                options: [
                    
                ]
            },
            {
                id: 'dateRange',
                label: 'Date range',
                type: 'select',
                options: [
                    {
                        id: 1000,
                        label: 'Today'
                    },
                    {
                        id: 1001,
                        label: 'Last 7 days'
                    },
                    {
                        id: 1002,
                        label: 'Last 4 weeks'
                    },
                    {
                        id: 1003,
                        label: 'Custom'
                    }
                ]
            }],

            cols: [{
                key: 'originalFilename',
                display: 'Filename'
            },
            {
                key: 'reportTypeLabel',
                display: 'Report Type'
            },
            {
                key: 'dateCreated',
                display: 'Date Created',
                showSort: true
            }],

            selectParams: {
                reportTypeId: null,
                startDate: null,
                endDate: null,
                orderBy: 'DateCreated',
                sortDirection: 'DESC'
            },

            reportTypes: []
        }
    },
    beforeMount() {
        this.select(this.selectParams)
        this.getReportTypes()

        },
    computed: {
        ...mapGetters({
            'reportList': 'reports/pagenatedList',
            'isLoading': 'reports/isLoading'
        }),
        reportFileUrl() {
                return '/api/admin/v1/download/'
        }
    },
    methods: {
        ...mapActions({
            'select': 'reports/select'
        }),
        handlePagination(payload) {
            this.selectParams.pageNumber = payload
            this.select(this.selectParams)
        },
        handleActionClick(payload) {
            reportsApiService.getDownloadKey()
                .then( response => {
                    window.open(
                        this.reportFileUrl + payload.item.id + '/' + response.data,
                        '_blank'
                    )
                })
        },
        getReportTypes() {
            let { reportTypes, searchInputs } = this

            reportsApiService.getReportTypes()
                .then(({ data }) => {
                    reportTypes = data.data
                    if (reportTypes) {
                        let idx = indexOfObject(searchInputs, 'id', 'reportType')
                        if (idx > -1) {
                            searchInputs[idx].options = reportTypes
                        }
                    }


                })
        },
        handleSearchClick(payload) {
            //console.log(payload)
            if (payload != null) {
                let { reportType, dateRange } = payload
                this.selectParams.reportTypeId = reportType ? reportType.id : null
                if (dateRange != null && dateRange.id != null) {
                    let rng = this.buildDateRange(dateRange.id)
                    this.selectParams.startDate = rng.startDate
                    this.selectParams.endDate = rng.endDate
                }
                this.select(this.selectParams)
            } else {
                this.selectParams = {}
                this.select(this.selectParams)
            }
        },
        handleClearClick() {
            this.selectParams = {}
            this.select(this.selectParams)
        },
        buildDateRange(id) {

            let formatDate = (dte) => {

                if (!(dte instanceof Date)) {
                    dte = new Date()
                } 

                return dte.getFullYear() + '-' + String(dte.getMonth() + 1).padStart(2, '0') + '-' + String(dte.getDate()).padStart(2, '0')
            }

            let today = new Date()
            let startDate = formatDate(today)
            let endDate = startDate + ' 23:59:59'
            switch (id) {
                case 1001:
                    // eslint-disable-next-line no-case-declarations
                    let dte1 = new Date()
                    dte1.setDate(dte1.getDate() - 7)
                    startDate = formatDate(dte1)
                    break;
                case 1002:
                    // eslint-disable-next-line no-case-declarations
                    let dte2 = new Date()
                    dte2.setDate(dte2.getDate() - 28)
                    startDate = formatDate(dte2)
                    break;
                default:
                    //startDate = startDate
            }
            return { startDate, endDate }
        },
        handleSortClick(col) {
            switch (col.key) {
                case 'dateCreated':
                    this.selectParams.orderBy = 'DateCreated'
                    if (this.selectParams.sortDirection == null || this.selectParams.sortDirection == 'ASC') {
                        this.selectParams.sortDirection = 'DESC'
                    } else {
                        this.selectParams.sortDirection = 'ASC'
                    }
                    break;
            }
            this.select(this.selectParams)
        }
    }
}
</script>

<style>
</style>
